import apiClient from '../config/api';

export interface ParamFormula {
  formulaId: number;
  paramName: string;
  naturalLanguageFormula: string;
  executableFormula: string | null;
  createdBy: string;
  modifiedBy: string;
  createdAt: string;
  modifiedAt: string;
}

function mapFormula(data: Record<string, unknown>): ParamFormula {
  return {
    formulaId: data.formula_id as number,
    paramName: data.param_name as string,
    naturalLanguageFormula: data.natural_language_formula as string,
    executableFormula: data.executable_formula as string | null,
    createdBy: data.created_by as string,
    modifiedBy: data.modified_by as string,
    createdAt: data.created_at as string,
    modifiedAt: data.modified_at as string,
  };
}

export async function listParamFormulas(): Promise<ParamFormula[]> {
  const response = await apiClient.get('/api/param-formulas');
  return (response.data.formulas || []).map(mapFormula);
}

export async function upsertParamFormula(body: {
  paramName: string;
  naturalLanguageFormula: string;
  executableFormula?: string;
}): Promise<ParamFormula> {
  const response = await apiClient.post('/api/param-formulas', body);
  return mapFormula(response.data.formula);
}

export async function deleteParamFormula(formulaId: number): Promise<void> {
  await apiClient.delete(`/api/param-formulas/${formulaId}`);
}
